'use client';

import { SwipeableDrawer } from '@mui/material';

import { styled } from '../../styles';

export const StyledSwipeableDrawer = styled(SwipeableDrawer, {
  shouldForwardProp: (prop) => prop !== 'withBorderRadius',
})<{ withBorderRadius?: boolean }>(({ withBorderRadius, theme }) => ({
  '& .MuiDrawer-paper': {
    maxHeight: '80%',
    borderTopRightRadius: withBorderRadius ? theme.spacing(4) : undefined,
    borderTopLeftRadius: withBorderRadius ? theme.spacing(4) : undefined,
    paddingTop: withBorderRadius ? theme.spacing(10) : undefined,
  },
}));
